import { FC } from 'react';
import { Modal as AntdModal } from 'antd';
import SearchFilterForm from '../Forms/SerachFilter/SearchFilterForm';

const CreateSearchFilterModal: FC<any> = ({ setIsOpen, isOpen, searchFilter }) => {
  const handleOk = () => {
    setIsOpen(false);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <>
      <AntdModal
        title='Basic Modal'
        open={isOpen}
        footer={null}
        onCancel={handleCancel}
      >
        <SearchFilterForm
          onCancel={handleCancel}
          onOk={handleOk}
          searchFilter={searchFilter}
        />
      </AntdModal>
    </>
  );
};

export default CreateSearchFilterModal;
